import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CollectionsIcon from '@mui/icons-material/Collections';
import HistoryIcon from '@mui/icons-material/History';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { baseTheme } from '@/core/theme/baseTheme';
import { DrawerMenu, type MenuItem } from '../DrawerMenu';
import { Footer } from '../Footer';
import { Header } from '../Header';

/** 共通画面のナビゲーション（すべて absolute パス） */
const menuItems: MenuItem[] = [
  { label: 'ギャラリー', path: '/gallery', absolute: true, icon: <CollectionsIcon /> },
  { label: '受け取り履歴', path: '/history', absolute: true, icon: <HistoryIcon /> },
  { label: 'ウォレット情報', path: '/wallet', absolute: true, icon: <AccountBalanceWalletIcon /> },
];

/**
 * 全大会共通画面のレイアウト
 * Header（RunPort ロゴ）+ コンテンツ + フッター
 * baseTheme（RunPort ブランドカラー）を適用
 */
export function CommonLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <ThemeProvider theme={baseTheme}>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header title="RunPort NFT" onMenuClick={() => setDrawerOpen(true)} />

        <Container component="main" maxWidth="sm" sx={{ flex: 1, py: 3 }}>
          <Outlet />
        </Container>

        <Footer />

        <DrawerMenu open={drawerOpen} onClose={() => setDrawerOpen(false)} menuItems={menuItems} raceAlias="" />
      </Box>
    </ThemeProvider>
  );
}
